import { DateTime, Settings } from 'luxon';
import { useEffect, useState } from 'react';
import { Calendar, luxonLocalizer, Views } from 'react-big-calendar';
import EventsService from '../../services/EventsService';

const localizer = luxonLocalizer(DateTime, { firstDayOfWeek: 7 });
const eventsService: EventsService = new EventsService();

type EventCategory = 'meeting' | 'fundraiser' | 'religious' | 'default';

const EVENT_COLORS: Record<EventCategory, string> = {
  meeting:    '#112866',  // blue
  fundraiser: '#EF3B39',  // red
  religious:  '#6f42c1',  // purple
  default:    '#0d945c',  // amber/gold
};

const CATEGORY_KEYWORDS: Record<EventCategory, string[]> = {
  meeting:    ['meeting', 'officers', 'council', 'assembly', 'chapter', 'board', 'social', 'planning', 'KofC'],
  fundraiser: ['fish fry', 'bingo', 'raffle', 'fundraiser', 'drive', 'sale', 'charity', 'donut'],
  religious:  ['mass', 'holy', 'church', 'retreat', 'adoration','Easter', 'Christmas','Lent','Advent',"Palm Sunday","Good Friday","Holy Thursday","Ash Wednesday"],
  default:    [],
};

function getEventCategory(title: string): EventCategory {
  const lower = title.toLowerCase();
  for (const [category, keywords] of Object.entries(CATEGORY_KEYWORDS) as [EventCategory, string[]][]) {
    if (category === 'default') continue;
    if (keywords.some(kw => lower.includes(kw?.toLocaleLowerCase()))) return category;
  }
  return 'default';
}

function EventsPage(props: any) {

  const [calendarEvents, setCalendarEvents] = useState<any[]>([]);

  const getEvents = async () => {
    const evs = await eventsService.getEventsForCalendar();
    setCalendarEvents(evs);
  }

  const onSelectEvent = async (e: any) => {
    if (e && e.id) {
      const event = await eventsService.getEventById(e.id);
      console.log("Event", event);
      if (event && event.href && event.href?.startsWith("http")) {
        window.open(event.href, "_blank");
      } else if (event && event.href && event.href?.startsWith("/")) {
        window.location = event.href;
      }
    }
  }

  const eventPropGetter = (event: any) => {
    const color = EVENT_COLORS[getEventCategory(event.title) as EventCategory];
    return { style: { backgroundColor: color, borderColor: color, borderRadius: '4px' } };
  };

  useEffect(() => {
    getEvents();
  }, []);

  const legendEntries: { label: string; category: EventCategory }[] = [
    { label: 'Meeting',    category: 'meeting' },
    { label: 'Fundraiser', category: 'fundraiser' },
    { label: 'Religious',  category: 'religious' },
    { label: 'Other',      category: 'default' },
  ];

  return (
    <div className="events-page">
      <h2>Events for Council 1056</h2>

      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '12px' }}>
        {legendEntries.map(({ label, category }) => (
          <span key={category} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.85rem' }}>
            <span style={{ width: 14, height: 14, borderRadius: 3, backgroundColor: EVENT_COLORS[category], display: 'inline-block' }} />
            {label}
          </span>
        ))}
      </div>

      <div className="events-calendar-frame">
        <Calendar
          localizer={localizer}
          events={calendarEvents}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          views={[Views.MONTH, Views.DAY]}
          defaultView={Views.MONTH}
          onSelectEvent={onSelectEvent}
          eventPropGetter={eventPropGetter}
        />
      </div>
    </div>
  );
}


export default EventsPage;